<button
  nbButton
  ghost
  status="primary"
  size="small"
  (click)="goBack()"
  class="back-button"
>
  <nb-icon icon="arrow-back-outline"></nb-icon>
  Back to Tools
</button>

<div *ngIf="isLoading" class="loading-container">
  <ngx-spinner
    color="#D73647"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="true"
    size="large"
  >
    <p>Loading SNP-level multi-endpoint viewer...</p>
  </ngx-spinner>
</div>

<div *ngIf="!isLoading" class="iframe-container">
  <iframe [src]="plotSrc" scrolling="no"></iframe>
</div>
